


































































import {
  Component, Model, Watch, Prop,
} from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { ValidationProvider } from 'vee-validate';
import ApiStatusMixin from '@/mixins/api-status';
import InputFile from '@/components/InputFile.vue';
import { ImageUploaderPreview } from '@/models/file';

function getImageDataUri(file: File) {
  return new Promise<ImageUploaderPreview | null>((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (event: ProgressEvent<FileReader>) => {
      const dataURI = event.target ? event.target.result : null;
      // console.log(dataURI);
      if (dataURI) {
        return resolve({
          path: dataURI,
          filename: file.name,
          date: file.lastModified,
        });
      }
      return reject(new Error('cannot parse this file'));
    };

    reader.onerror = () => {
      reject(new Error('cannot parse this file'));
    };

    reader.readAsDataURL(file);
  });
}

export interface SingleImageUpload {
    file?: File | null;
    previewPath: string | null;
    previewFilename: string | null;
  }

@Component({
  components: {
    InputFile,
  },
})
export default class SingleImageUploader extends mixins(
  ApiStatusMixin,
) {
  @Model('input', { type: [Object] })
  readonly value!: SingleImageUpload;

  @Prop({
    type: [String, Object],
  })
  rules!: string | string;

  @Prop({
    type: String,
  })
  label!: string;

  @Prop({
    type: String,
  })
  description!: string;

  @Prop({
    type: Boolean,
    default: true,
  })
  autoRemoveInvalid!: boolean;

  $refs!: {
    singleFileValidationProvider: InstanceType<typeof ValidationProvider>;
  }

  imageFile: File | null = this.value.file || null;

  previewPath: string | null = this.value.previewPath || null;

  previewFilename: string | null = this.value.previewFilename || null;

  originalData: SingleImageUpload = {
    previewPath: this.value.previewPath,
    previewFilename: this.value.previewFilename,
  }

  get uploadedFile() {
    return this.imageFile !== null;
  }

  get hasError() {
    return this.$refs.singleFileValidationProvider.flags.failed;
  }

  @Watch('imageFile')
  onImageFileChanged() {
    this.emitModelChange();
  }

  @Watch('previewPath')
  onPreviewPathChanged() {
    this.emitModelChange();
  }

  @Watch('previewFilename')
  onPreviewFilenameChanged() {
    this.emitModelChange();
  }

  @Watch('value')
  onValueChanged(newValue: SingleImageUpload) {
    // this.localList = newValue.split(',');
    this.imageFile = newValue.file || null;
    this.previewPath = newValue.previewPath;
    this.previewFilename = newValue.previewFilename;
  }

  emitModelChange() {
    this.$emit('input', {
      file: this.imageFile,
      previewPath: this.previewPath,
      previewFilename: this.previewFilename,
    });
  }

  setOriginalData() {
    this.originalData.previewPath = this.previewPath;
    this.originalData.previewFilename = this.previewFilename;
  }

  resetToDefault() {
    this.imageFile = null;
    this.previewPath = this.originalData.previewPath || null;
    this.previewFilename = this.originalData.previewFilename || null;
  }

  async onFilesChange(files: File[]) {
    try {
      // console.log(files);
      if (!files || files[0] === null) {
        // console.log('no files');
        this.resetToDefault();
        return;
      }

      const validate = await this.$refs.singleFileValidationProvider.validate();

      // console.log(validate);

      if (validate.valid === true) {
        const imageData = await getImageDataUri(files[0]);

        this.imageFile = files[0] as File;
        this.previewPath = imageData?.path as string;
        this.previewFilename = imageData?.filename as string;

        return;
      }

      if (this.autoRemoveInvalid === true) {
        this.resetToDefault();
        this.$notify.show('error filled', validate.errors[0], '選擇圖片', {
          duration: 5000,
          permanent: false,
        });
        this.$refs.singleFileValidationProvider.reset();
        return;
      }
    } catch (error) {
      console.error(error);
    }
  }
}
